export default __webpack_public_path__ + "static/media/logo.c9403c24.png";